var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';
import LocalPostOffice from '@mui/icons-material/LocalPostOffice';
import { Can, CanAny } from "../../App/utils/Authorize";
import Impersonate from "../../App/components/Impersonate";
import Notification from "../../App/components/Notification";
import CustomerService from "../../Customer/services/CustomerService";
import { handleServiceError } from "../../App/components/ErrorHandler";
import { useNavigate } from "react-router-dom";
var ProviderActionsMenu = function (_a) {
    var item = _a.item;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var navigate = useNavigate();
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    function sendEmail(customer_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Notification().Confirm.show("Email de Primeiro Acesso", "Este e-mail contém o link de criação de senha para conceder acesso à plataforma. Tem certeza que deseja enviar?", "Enviar", "Cancelar", function () {
                    Notification().Block.circle("[data-id=providers-grid]");
                    CustomerService.sendMail(customer_id).then(function (res) {
                        Notification().Notify.success(res.data.response);
                        Notification().Block.remove("[data-id=providers-grid]");
                    }, function (err) {
                        handleServiceError(err);
                    });
                });
                Notification().Block.remove("[data-id=providers-grid]");
                return [2 /*return*/];
            });
        });
    }
    function editProvider(customerId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                CustomerService.find(customerId).then(function (res) {
                    navigate("/providers/".concat(res.data.customer.id, "/update"), {
                        state: {
                            provider: res.data.customer,
                            user: res.data.customer.main_user
                        }
                    });
                }, function (err) {
                    handleServiceError(err);
                });
                return [2 /*return*/];
            });
        });
    }
    function getActiveProducts(customerId, provider) {
        navigate("/providers/".concat(customerId, "/products"), { state: { provider: provider } });
    }
    return (_jsxs(CanAny, __assign({ permissions: ["update-customer", "impersonate-customer", "send-firstAccessEmail"] }, { children: [_jsx(Button, __assign({ id: "basic-button", "aria-controls": open ? 'basic-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, "aria-label": "Mais a\u00E7\u00F5es para ".concat(item.name), onClick: handleClick }, { children: _jsx(MoreHorizIcon, {}) })), _jsxs(Menu, __assign({ id: "basic-menu", anchorEl: anchorEl, open: open, onClose: handleClose, sx: {
                    '& .MuiMenuItem-root': {
                        fontFamily: "Gabarito, sans-serif",
                    }
                } }, { children: [_jsx(Can, __assign({ permission: "update-customer" }, { children: _jsxs(MenuItem, __assign({ onClick: function () { handleClose(); editProvider(item.id); } }, { children: [_jsx(EditIcon, { style: { marginRight: "0.5rem" } }), "Editar Dados"] })) })), _jsx(Can, __assign({ permission: "send-firstAccessEmail" }, { children: _jsxs(MenuItem, __assign({ onClick: function () { sendEmail(item.id); handleClose(); } }, { children: [_jsx(LocalPostOffice, { style: { marginRight: "0.5rem" } }), "Enviar E-mail de Acesso"] })) })), _jsx(Can, __assign({ permission: "impersonate-customer" }, { children: _jsx(Impersonate, { customerId: item.id }) }))] }))] })));
};
export default ProviderActionsMenu;
